import { render, staticRenderFns } from "./MobileFormPermissionManager.vue?vue&type=template&id=7a97d49d&scoped=true&"
import script from "./MobileFormPermissionManager.vue?vue&type=script&lang=js&"
export * from "./MobileFormPermissionManager.vue?vue&type=script&lang=js&"
import style0 from "./MobileFormPermissionManager.vue?vue&type=style&index=0&id=7a97d49d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a97d49d",
  null
  
)

export default component.exports